import axios from "axios";
import axiosRetry from "axios-retry";

export const axiosInstance = axios.create({
	baseURL: `/business-directory/api/`
	// timeout: 5000
});

axiosRetry(axiosInstance, {
	"retries": 2,
	"retryCondition": (error) => error.response === undefined || error.response.status === 500,
});
